import { v4 as uuidv4 } from 'uuid';
import { MarketingEventsProductsGrid } from './MarketingEventsProductsGrid';
import i18n from '../../../../i18n';
import { MarketingEventsProductsGridPluginSettings } from './MarketingEventsProductsPluginSettings';

export const MarketingEventsProductsTab = (): ITab => {
    const t = (value: string) => i18n.t("sidePanel.directory.submenu." + value);
    return {
        id: uuidv4(),
        title: t("marketingEventsProducts"),
        view: {
            content: MarketingEventsProductsGridPluginSettings
                ? <MarketingEventsProductsGrid gridId={uuidv4()} plugin={MarketingEventsProductsGridPluginSettings} />
                : <p> Справочник не настроен</p>
        }
    }
}
